export default {
  mapbox: {
    accessToken:
      'pk.eyJ1IjoiYW1hdGVrIiwiYSI6ImNrajMxZXB5ajNnOHgycHNjNDd3MWY5dzQifQ.CbOtRosnF63e_ESfwpeCDQ',
  },
};
